import React, { useState } from "react";
import { Modal, Input, Button } from "antd";

const DeleteTenantConfirmModal = ({ visible, tenant, onDelete, onCancel }) => {
  const [inputCode, setInputCode] = useState("");

  const isMatch = inputCode === tenant?.tenantCode;

  const handleChange = (e) => setInputCode(e.target.value);

  const handleOk = () => {
    if (isMatch) {
      onDelete(tenant.id);
      setInputCode("");
    }
  };

  const handleCancel = () => {
    onCancel();
    setInputCode("");
  };

  return (
    <Modal
      visible={visible}
      title={`Delete tenant "${tenant?.tenantName}"`}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Delete"
      okButtonProps={{ disabled: !isMatch, danger: true }}
      cancelText="Cancel"
      destroyOnClose
    >
      <p>
        To confirm deletion, please type the tenant code: <b>{tenant?.tenantCode}</b>
      </p>
      <Input
        placeholder="Enter tenant code here"
        value={inputCode}
        onChange={handleChange}
        autoFocus
      />
      {!isMatch && inputCode.length > 0 && (
        <p style={{ color: "red", marginTop: 8 }}>
          Tenant code does not match.
        </p>
      )}
    </Modal>
  );
};

export default DeleteTenantConfirmModal;
